import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 35px 0 15px;

  @media (min-width: 768px) {
    padding: 70px 0 30px;
  }
`;

const Container = styled.div`
  margin: 0 auto;
  padding: 0 18px;
  max-width: 1140px;
`;

const Heading = styled.h1`
  font-size: 21px;
  line-height: 17px;
  color: #294f79;
  font-weight: 500;
  margin-bottom: 40px;
  text-align: center;

  @media (min-width: 768px) {
    font-size: 32px;
    line-height: 34px;
  }
`;

const Reason = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 800px;
  margin: 0 auto 35px;

  @media (min-width: 768px) {
    margin-bottom: 38px;
  }
`;

const ReasonNo = styled.span`
  font-size: 49px;
  line-height: 30px;
  color: #14b350;
  font-family: 'Ubuntu';
  font-weight: 300;
  margin-right: 20px;

  @media (min-width: 768px) {
    margin-right: 16px;
  }
`;

const ReasonText = styled.p`
  font-size: 13px;
  line-height: 22px;
  font-weight: 300;
  border-left: 2px solid #bebebe;
  padding-left: 25px;

  @media (min-width: 768px) {
    font-size: 16px;
    line-height: 30px;
    border-left: 1px solid #bebebe;
    padding-left: 40px;
  }
`;

export { Wrapper, Container, Heading, Reason, ReasonNo, ReasonText };
